import { Box, Button, Flex, FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import { isValidEmail } from '@common/utility/validations';
import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useAccountInfoViewModel } from '../models/InfoViewModel';
import { InfoForm } from '../types';

type EmailFieldProps = {
  infoForm: UseFormReturn<InfoForm>;
  currentEmail: string | null;
  showEmailDialog: () => void;
};

export const EmailField: React.FC<EmailFieldProps> = ({ infoForm, currentEmail, showEmailDialog }) => {
  const [showEditEmail, setShowEditEmail] = useState(false);
  const errors = infoForm.formState.errors;
  const viewModel = useAccountInfoViewModel();

  return (
    <Box>
      <Flex justifyContent={'space-between'}>
        <TextBlock color={'gray.600'}>Email</TextBlock>
        <Button
          onClick={() => {
            setShowEditEmail(!showEditEmail);
          }}
          variant="link">
          {showEditEmail ? 'Cancel' : 'Edit'}
        </Button>
      </Flex>

      <TextBlock weight="bold">{currentEmail || ''}</TextBlock>
      {showEditEmail && (
        <Flex alignItems={'flex-start'} style={{ marginTop: 10 }}>
          <FormControl isInvalid={Boolean(errors.email)}>
            <Input
              id="email"
              placeholder=""
              {...infoForm.register('email', {
                required: 'Please enter an email',
                validate: (v) => isValidEmail(v) || 'Please use a valid email address',
              })}
              autoFocus={true}
            />
            <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
          </FormControl>
          <Button
            onClick={async () => {
              if (!errors.email) {
                viewModel.setState('LOADING');
                const status = await viewModel.updateEmailAddress(infoForm.getValues().email);
                if (status.success) {
                  showEmailDialog();
                  setShowEditEmail(false);
                } else {
                  alert(status.error);
                }
                viewModel.setState('RENDER');
              }
            }}
            style={{ marginLeft: '15px' }}>
            Update
          </Button>
        </Flex>
      )}
    </Box>
  );
};
